module.exports = __webpack_public_path__ + "static/media/it_logo.89e323cd.jpg";